/* istanbul ignore file */
import React, { useState } from 'react';
import { useAuthorization } from 'framework/authorization';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import AssignLeadOwnerForm from 'domain/sales/lead/shared/input/AssignLeadOwnerForm';
import { useShowContext } from 'framework/show';
import { CHANGE_OWNER } from 'domain/sales/salesService';

const AssignLeadOwnerButton = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { data: lead } = useShowContext();
  const { isGranted } = useAuthorization();

  const closeModal = () => {
    setModalOpen(false);
  };

  const currentLeadStatus = lead.getValueBySource('status');
  const isCorrectStatus = currentLeadStatus === 'NEW' || currentLeadStatus === '';
  const isButtonVisible = isCorrectStatus && isGranted(CHANGE_OWNER);

  return isButtonVisible ? (
    <>
      <Button
        sx={{ ml: 1 }}
        variant="outlined"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          setModalOpen(true);
          (e.target as HTMLElement).blur();
        }}
      >
        Assign lead owner
      </Button>
      <Modal
        backdrop="static"
        isOpen={modalOpen}
        title="Assign lead owner"
        onToggle={closeModal}
        hasCancelButton={false}
        className="qualification-modal"
      >
        <AssignLeadOwnerForm closeModal={closeModal} modalOpen={modalOpen} isGranted={isButtonVisible} />
      </Modal>
    </>
  ) : null;
};

export default AssignLeadOwnerButton;
